import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SafeIcon from '../../common/SafeIcon';

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '', lastName: '', email: '', password: '', 
    confirmPassword: '', orgName: '', role: 'participant'
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    if (formData.password !== formData.confirmPassword) return setError('Passwords do not match');
    
    setLoading(true);
    try {
      await register(
        formData.email,
        formData.password,
        { first_name: formData.firstName, last_name: formData.lastName, role: formData.role },
        formData.orgName
      );
      navigate('/portal/login', { state: { message: 'Registration successful! Please log in.' } });
    } catch (err) {
      setError(err.message || 'Registration failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy-900 flex items-center justify-center p-4 py-12">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl p-8 border border-slate-200">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-navy-900 rounded-xl flex items-center justify-center mx-auto mb-4">
            <span className="text-gold-500 font-serif font-bold text-3xl">K</span>
          </div>
          <h1 className="text-2xl font-serif font-bold text-navy-900">Create Account</h1>
        </div>

        {error && <div className="bg-red-50 text-red-600 p-4 rounded-lg text-sm mb-6 flex items-center gap-2 border border-red-100"><SafeIcon name="AlertTriangle" className="w-5 h-5" />{error}</div>}

        <form onSubmit={handleRegister} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <input type="text" placeholder="First Name" required value={formData.firstName} onChange={e => setFormData({...formData, firstName: e.target.value})} className="px-4 py-3 rounded-xl border border-slate-200 outline-none focus:border-navy-900" />
            <input type="text" placeholder="Last Name" required value={formData.lastName} onChange={e => setFormData({...formData, lastName: e.target.value})} className="px-4 py-3 rounded-xl border border-slate-200 outline-none focus:border-navy-900" />
          </div>
          <input type="email" placeholder="Email Address" required value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} className="w-full px-4 py-3 rounded-xl border border-slate-200 outline-none focus:border-navy-900" />
          <div className="grid grid-cols-2 gap-4">
            <input type="text" placeholder="Organisation" required value={formData.orgName} onChange={e => setFormData({...formData, orgName: e.target.value})} className="px-4 py-3 rounded-xl border border-slate-200 outline-none focus:border-navy-900" />
            <select value={formData.role} onChange={e => setFormData({...formData, role: e.target.value})} className="px-4 py-3 rounded-xl border border-slate-200 bg-white">
              <option value="participant">Participant</option>
              <option value="manager">Manager</option>
              <option value="compliance">Compliance</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <input type="password" placeholder="Password" required minLength="8" value={formData.password} onChange={e => setFormData({...formData, password: e.target.value})} className="px-4 py-3 rounded-xl border border-slate-200 outline-none focus:border-navy-900" />
            <input type="password" placeholder="Confirm" required value={formData.confirmPassword} onChange={e => setFormData({...formData, confirmPassword: e.target.value})} className="px-4 py-3 rounded-xl border border-slate-200 outline-none focus:border-navy-900" />
          </div>
          <button type="submit" disabled={loading} className="w-full bg-navy-900 text-white py-4 rounded-xl font-bold hover:bg-navy-800 shadow-xl disabled:opacity-50 transition-all">
            {loading ? 'Processing...' : 'Register'}
          </button>
        </form>
        <div className="mt-6 text-center text-sm text-slate-500">
          Already have an account? <Link to="/portal/login" className="text-navy-900 font-bold hover:underline">Sign In</Link>
        </div>
      </div>
    </div>
  );
};

export default Register;